// src/components/NewSocialLinksForm.js
import React from 'react';

export default function NewSocialLinksForm({
                                               links,
                                               customLinks = [],
                                               onChange,
                                               onCustomLinksChange,
                                               onSubmit,
                                               onCancel,
                                               // NEW props for 3-button footer
                                               enablePublishButton = false,
                                               onSubmitAndPublish,
                                           }) {
    const safeLinks = links || {};

    const normalizeLinkValue = (value) => {
        if (typeof value === 'string') return { url: value, label: '' };
        if (value && typeof value === 'object') {
            return { url: value.url || value.link || '', label: value.label || value.name || '' };
        }
        return { url: '', label: '' };
    };

    const updateLink = (field, next) => onChange({ ...safeLinks, [field]: next });

    const handleUrlChange = (field, value) => {
        const current = normalizeLinkValue(safeLinks[field]);
        updateLink(field, { ...current, url: value });
    };

    const handleLabelChange = (field, value) => {
        const current = normalizeLinkValue(safeLinks[field]);
        updateLink(field, { ...current, label: value });
    };

    const handleSave = () => {
        onSubmit?.(links);
    };

    const handleSaveAndPublish = () => {
        onSubmitAndPublish?.(links);
    };

    const fields = [
        'instagram',
        'facebook',
        'twitter',
        'threads',
        'exchangeArt',
        'mallow',
        'drip',
        'bluesky',
        'tiktok',
        'reddit',
        'youtube',
        'github',
        'linkedin',
        'website',
    ];

    const formatFieldName = (field) => {
        if (field === 'exchangeArt') return 'Exchange Art';
        if (field === 'tiktok') return 'TikTok';
        if (field === 'linkedin') return 'LinkedIn';
        if (field === 'github') return 'GitHub';
        if (field === 'youtube') return 'YouTube';
        return field.charAt(0).toUpperCase() + field.slice(1);
    };

    const handleAddCustomLink = () => {
        const next = [
            ...(Array.isArray(customLinks) ? customLinks : []),
            { id: `${Date.now()}-${Math.random().toString(16).slice(2)}`, url: '', label: '' }
        ];
        onCustomLinksChange?.(next);
    };

    const handleCustomLinkChange = (idx, patch) => {
        const next = (Array.isArray(customLinks) ? customLinks : []).map((link, i) =>
            i === idx ? { ...link, ...patch } : link
        );
        onCustomLinksChange?.(next);
    };

    const handleRemoveCustomLink = (idx) => {
        const next = (Array.isArray(customLinks) ? customLinks : []).filter((_, i) => i !== idx);
        onCustomLinksChange?.(next);
    };

    return (
        <div className="new-component-form social-form">
            <div className="social-form-header">
                <h1>Social Links</h1>
                <p>Add your profiles and set the name that appears next to each icon.</p>
            </div>

            <div className="social-form-grid">
                {fields.map((field) => {
                    const normalized = normalizeLinkValue(safeLinks[field]);
                    return (
                        <div key={field} className="social-form-field">
                            <label className="social-form-label">
                                {formatFieldName(field)} URL
                                <input
                                    type="url"
                                    placeholder={`${formatFieldName(field)} URL`}
                                    value={normalized.url}
                                    onChange={(e) => handleUrlChange(field, e.target.value)}
                                    className="muulti-input"
                                />
                            </label>
                            <label className="social-form-label">
                                Display name (optional)
                                <input
                                    type="text"
                                    placeholder="Override the auto-extracted name"
                                    value={normalized.label}
                                    onChange={(e) => handleLabelChange(field, e.target.value)}
                                    className="muulti-input"
                                />
                            </label>
                        </div>
                    );
                })}
            </div>

            <div className="social-form-custom">
                <div className="social-form-custom-header">
                    <h3>Additional links</h3>
                    <button onClick={handleAddCustomLink} className="muulti-button social-form-add">
                        Add link
                    </button>
                </div>

                {(Array.isArray(customLinks) ? customLinks : []).map((link, idx) => (
                    <div key={link?.id || `custom-${idx}`} className="social-form-custom-row">
                        <label className="social-form-label">
                            URL
                            <input
                                type="url"
                                placeholder="https://"
                                value={link?.url || ''}
                                onChange={(e) => handleCustomLinkChange(idx, { url: e.target.value })}
                                className="muulti-input"
                            />
                        </label>
                        <label className="social-form-label">
                            Display name (optional)
                            <input
                                type="text"
                                placeholder="e.g. My Portfolio"
                                value={link?.label || ''}
                                onChange={(e) => handleCustomLinkChange(idx, { label: e.target.value })}
                                className="muulti-input"
                            />
                        </label>
                        <button
                            type="button"
                            onClick={() => handleRemoveCustomLink(idx)}
                            className="muulti-button social-form-remove"
                        >
                            Remove
                        </button>
                    </div>
                ))}
            </div>

            <div className="muulti-container-button-container">
                <button onClick={handleSave} className="muulti-button">
                    Save Panel
                </button>

                {enablePublishButton && (
                    <button onClick={handleSaveAndPublish} className="muulti-button">
                        Save Panel &amp; Publish
                    </button>
                )}

                <button onClick={onCancel} className="muulti-button">
                    Cancel
                </button>
            </div>
        </div>
    );
}
